import { Box, Card, Link, Typography } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';
import { MapTrifold as Map, CurrencyDollar as AttachMoney, TrendUp as TrendingUp, ArrowRight, Ranking as Leaderboard } from '@phosphor-icons/react';
import { PageHeader } from '../../components/common/PageHeader';

const availableReports = [
  {
    title: 'Sales Reports',
    description: 'Company-wide metrics, rep performance, pipeline analytics, and trends',
    icon: <Leaderboard />,
    route: '/reports/sales',
    status: 'active',
  },
  {
    title: 'Canvassing Map',
    description: 'Visualize door-to-door canvassing activity on an interactive map',
    icon: <Map />,
    route: '/reports/canvasing',
    status: 'active',
  },
  {
    title: 'Billing Reports',
    description: 'Revenue analysis, aging reports, and profitability metrics',
    icon: <AttachMoney />,
    route: '/reports/billing',
    status: 'active',
  },
  {
    title: 'Sales Pipeline',
    description: 'Track opportunities through your sales funnel with conversion metrics',
    icon: <TrendingUp />,
    route: '/crm/pipeline',
    status: 'active',
  },
];

export default function ReportsPage() {
  return <Box sx={{ p: { xs: 1.5, md: 3 }, width: '100%', maxWidth: 1200, mx: 'auto' }}>
    <PageHeader title="Reports & Analytics" description="Choose what you want to understand: sales performance, field activity, billing, or your current pipeline. Open a report to explore its filters and details." />
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }, gap: 2 }}>
      {availableReports.map(report => <Card key={report.route} variant="outlined" sx={{ p: 2.5 }}>
        <Box sx={{ color: 'primary.plainColor', fontSize: 28 }}>{report.icon}</Box>
        <Typography level="title-lg">{report.title}</Typography>
        <Typography level="body-sm" sx={{ color: 'text.secondary', flex: 1 }}>{report.description}</Typography>
        <Link component={RouterLink} to={report.route} endDecorator={<ArrowRight />} sx={{ mt: 1 }}>Open {report.title.toLowerCase()}</Link>
      </Card>)}
    </Box>
  </Box>;
}
